import { createBrowserRouter } from "react-router-dom";

import {
  ROUTE_DATA_PROCESSOR,
  ROUTE_NOT_FOUND,
  ROUTE_PO,
  ROUTE_PRIVACY_POLICY,
  ROUTE_RESULT,
} from "@/routes/routeNames";

export const makeRoutes = () => {
  return createBrowserRouter([
    {
      lazy: () => import("./root"),
      children: [
        {
          path: ROUTE_PO,
          lazy: () => import("./po"),
        },
        {
          path: ROUTE_RESULT,
          lazy: () => import("./result"),
        },
      ],
    },
    {
      path: ROUTE_PRIVACY_POLICY,
      lazy: () => import("./privacy-policy"),
    },
    {
      path: ROUTE_DATA_PROCESSOR,
      lazy: () => import("./data-processor"),
    },
    {
      path: ROUTE_NOT_FOUND,
      lazy: () => import("./not-found"),
    },
  ]);
};
